import type { CookieKey } from ':shared/enums';

function getCookies(): string[] {
    return document.cookie.split(';');
}

export function getCookie(name: CookieKey): string | null {
    const cookies = getCookies();
    const cookie = cookies.find((row) => row.trim().startsWith(`${name}=`));
    return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
}
